export type DeepLinkQuery = Record<string, string | string[] | undefined>;

export type GetDeepLink = {
  /**
   * Support different route structures and null/undefined values (genderless support)
   * Examples:
   *  - ["product-category", gender, slug] = "/product-category/women/clothing" or "/product-category/clothing" for genderless
   */
  route: (string | undefined | null)[];
  query?: DeepLinkQuery;
};

function serializeQuery(query: DeepLinkQuery): string {
  return Object.entries(query).reduce<string>((acc, [key, value]) => {
    if (!value) {
      return acc;
    }

    if (Array.isArray(value)) {
      return `${acc}${acc.length === 0 ? "" : "&"}${key}=${value.join(
        `&${key}=`
      )}`;
    }

    return `${acc}${acc.length === 0 ? "" : "&"}${key}=${value}`;
  }, "");
}

function getDeepLink({ route, query }: GetDeepLink): string {
  const path = route.filter(Boolean).join("/");
  const queryString = query ? serializeQuery(query) : "";

  return `otrium://${path}${queryString ? `?${queryString}` : ""}`;
}

export { getDeepLink };
